import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNConsultation } from 'src/app/models/cnconsultation';
import { ServicesService } from 'src/app/services/services.service';
import * as moment from 'moment';
import { CNServiceCodeGroup } from 'src/app/models/cnservicecodegroup';
import { CNServiceCode } from 'src/app/models/cnservicecode';

@ManageType('ServiceCodeGroupComponent')
@Component({
  selector: 'app-service-code-group',
  templateUrl: './service-code-group.component.html',
  styleUrls: ['./service-code-group.component.scss']
})
export class ServiceCodeGroupComponent implements OnInit {

  @Input() group: CNServiceCodeGroup;
  @Output() action: EventEmitter<[action: string, code: CNServiceCode]> = new EventEmitter();

  constructor(public services: ServicesService) { }

  ngOnInit(): void {
  }

  codeAction(action: [string, CNServiceCode]) {
    this.action.emit(action);
  }
}
